import React, { useEffect } from "react";
import { useState } from "react";
import { INPUT_STYLE } from "../../assets/constants";
import { useNavigate } from "react-router-dom";

import SimpleAlert from "../../theme/alerts/SimpleAlert";
function Table({
    tableTitle,
    data,
    columns,
    setData,
    forAllStudents,
    forNewAssesment,
    forUpdateAssesment,
}) {
    const user = JSON.parse(localStorage.getItem("user"));

    const navigate  = useNavigate();
    const [tableData, setTableData] = useState([]);
    const [errors, setErrors] = useState({
        obtainedMarksError: null,
        totalMarksError: null,
        percentageError: null
    })
    const [record, setRecord] = useState({
        studentId: null,
        name: null,
        obtainedMarks: null,
        totalMarks: null,
        percentage: null
    });
    // const navigate = useNavigate()
    useEffect(() => {
        if (!forAllStudents) {
            let result = data.map(data => {
                return {
                    studentId: data.studentId,
                    name: data.name,
                    obtainedMarks: null,
                    totalMarks: null,
                    percentage: null,
                    totalMarksError: null,
                    obtainedMarksError: null,
                    percentageError: null
                }
            })
            setTableData(result);
            console.log(result)
        } else {
            setTableData(data);
        }

    }, [data]);

    // const handleViewClick = (id) => {
    //     alert("View clicked");

    //     setStudent(result[0]);
    //     setShowStudent(true);
    // };
    if (data?.length < 1 && !forNewAssesment) {
        return (
            <div className="flex flex-col justify-center items-center mt-[20%] text-lg font-semibold">
                <div className="text-3xl">😌</div>
                <div>No content found to preview</div>
            </div>
        );
    }
    return (
        <div>
            <div className="sm:px-6 w-full">
                <div className="px-4 md:px-10 py-4 md:py-7">
                    <div className="flex items-center justify-between">
                        <p
                            tabIndex="0"
                            className="uppercase focus:outline-none text-base sm:text-lg md:text-xl lg:text-2xl font-bold leading-normal text-gray-800"
                        >
                            {tableTitle}
                        </p>
                    </div>
                </div>
                <div className="bg-white py-4  px-4  xl:px-10 rounded-lg">
                    <div className="my-7 overflow-x-auto">
                        <table className="w-full whitespace-nowrap ">
                            {/* Heading/coumns */}
                            <thead className=" font-semibold uppercase text-white  bg-blue-500">
                                <tr className="">
                                    {/* Heading / tabs for data table */}
                                    {columns?.map((column) => (
                                        <th className="py-2 whitespace-nowrap first:pl-3 px-2">
                                            <div className="font-semibold text-left">{column}</div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            {/* rows */}
                            <tbody>
                                {tableData.map((student, index) => {
                                    if (forAllStudents) {
                                        return (
                                            <tr
                                                key={index}
                                                tabIndex="0"
                                                className=" focus:outline-none h-16 border text-gray-600 odd:bg-white even:bg-slate-50 hover:bg-blue-100 hover:text-blue-500"
                                            >
                                                <td className="pl-3">
                                                    <div className="flex items-center">
                                                        <p className="text-md leading-none font-bold  ">
                                                            {student?.name}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td className="pl-2">
                                                    <div className="flex items-center ">
                                                        <p className=" leading-none  ">
                                                            {student?.studentId}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td className="pl-2">
                                                    <div className="flex items-center ">
                                                        <p className=" leading-none  ">
                                                            {student?.email}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td className="pl-2">
                                                    <div className="flex items-center ">
                                                        <p className=" leading-none  ">
                                                            {student?.birthDate}
                                                        </p>
                                                    </div>
                                                </td>

                                                <td className="">
                                                    <div className="flex items-center justify-center">
                                                        <button
                                                            className="focus:ring-2 focus:ring-offset-2 focus:ring-blue-500  leading-none py-3 px-5 bg-gray-100 rounded hover:bg-blue-200 focus:outline-none"
                                                           
                                                            onClick={() => {
                                                                navigate(`/dashboard/${user.role.toLowerCase()}/student-profile`, {
                                                                    state: { id: student.studentId },
                                                                });
                                                            }}
                                                        >
                                                            View
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (forNewAssesment || forUpdateAssesment) {
                                        return (
                                            <tr
                                                key={index}
                                                tabIndex="0"
                                                className=" focus:outline-none h-16 border text-gray-600 odd:bg-white even:bg-slate-50 hover:bg-blue-100 hover:text-blue-500"
                                            >
                                                <td className="pl-3">
                                                    <div className="flex items-center">
                                                        <p className="text-md leading-none font-bold  ">
                                                            {student?.name}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td className="pl-2">
                                                    <div className="flex items-center ">
                                                        <p className=" leading-none  ">
                                                            {student?.studentId}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td className="pl-2">
                                                    <input
                                                        type="number"
                                                        min="0" max="100"
                                                        maxLength={0}
                                                        className={`appearance-none m-0 p-0 ${INPUT_STYLE} w-fit h-10  text-md font-normal ${student.obtainedMarksError && "border-red-600 text-red-600"}`}
                                                        value={student.obtainedMarks}
                                                        onChange={(e) => {
                                                            const list = [...tableData];
                                                            list[index]["obtainedMarks"] = e.target.value;
                                                            list[index]["obtainedMarksError"] = null;
                                                            setTableData(list)
                                                        }}
                                                        onBlur={() => {
                                                            const list = [...tableData];
                                                            if (student?.obtainedMarks < 0) {
                                                                list[index]["obtainedMarksError"] = "Obtained marks must be positive";
                                                            }
                                                            if (student.obtainedMarks && student.totalMarks) {
                                                                list[index]["percentage"] = ((student.obtainedMarks / student.totalMarks) * 100).toFixed(2)
                                                            }
                                                            setTableData(list)
                                                        }}
                                                    />
                                                </td>
                                                <td className="pl-2">
                                                    <input
                                                        type="number"
                                                        min="0" max="100"
                                                        maxLength={0}
                                                        className={`appearance-none m-0 p-0 ${INPUT_STYLE} w-fit h-10  text-md font-normal ${student.totalMarksError && "border-red-600 text-red-600"}`}
                                                        value={student.totalMarks}
                                                        onChange={(e) => {
                                                            const list = [...tableData];
                                                            list[index]["totalMarks"] = e.target.value;
                                                            list[index]["totalMarksError"] = null;
                                                            setTableData(list)
                                                        }}
                                                        onBlur={() => {
                                                            const list = [...tableData];
                                                            if (student?.totalMarks < 0) {
                                                                list[index]["totalMarksError"] = "Total marks must be positive";
                                                            }
                                                            if (student.obtainedMarks && student.totalMarks) {
                                                                list[index]["percentage"] = ((student.obtainedMarks / student.totalMarks) * 100).toFixed(2)
                                                            }
                                                            setTableData(list)
                                                        }}
                                                    />
                                                </td>
                                                <td className="pl-2">
                                                    <input
                                                        type="number"
                                                        className={`appearance-none m-0 p-0 ${INPUT_STYLE} w-24 h-10  text-md font-normal`}
                                                        value={(student.obtainedMarks && student.totalMarks) && ((student.obtainedMarks / student.totalMarks) * 100).toFixed(2)}
                                                        disabled={true}
                                                    // onChange={(e) => {
                                                    //     setRecord((prev) => ({
                                                    //         ...prev,
                                                    //         percentage: e.target.value
                                                    //     }))
                                                    // }}
                                                    />
                                                </td>

                                                <td className="">
                                                    <div className="flex items-center justify-center">
                                                        <button
                                                            className="focus:ring-2 focus:ring-offset-2 focus:ring-blue-500  leading-none py-3 px-5 bg-gray-100 rounded hover:bg-blue-200 focus:outline-none"
                                                            onClick={() => {
                                                                const result = tableData.filter((item) => item?.studentId === student.studentId)[0];
                                                                console.log(result);
                                                                localStorage.setItem('studentMarks', JSON.stringify(result));
                                                                // SimpleAlert("Success", "Student marks added", "success", 1500)
                                                                // SimpleAlert("Error", "Unable to add student marks","error",1500 )
                                                            }}
                                                        >
                                                            {forNewAssesment ? "Add" : "Update"}
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                })}
                                {/* {
                                    forNewAssesment && <tr
                                        tabIndex="0"
                                        className=" focus:outline-none h-16 border text-gray-600 odd:bg-white even:bg-slate-50 hover:bg-blue-100 hover:text-blue-500"
                                    >
                                        <td className="pl-3">
                                            <input
                                                type="text"
                                                className={`appearance-none m-0 p-0 ${INPUT_STYLE} w-fit h-10  text-md font-normal`}
                                                value={record.name}
                                                onChange={(e) => {
                                                    setRecord((prev) => ({
                                                        ...prev,
                                                        name: e.target.value
                                                    }))
                                                }}
                                            />
                                        </td>
                                        <td className="pl-2">
                                            <input
                                                type="text"
                                                className={`appearance-none m-0 p-0 ${INPUT_STYLE} w-fit h-10  text-md font-normal`}
                                                value={record.studentId}
                                                onChange={(e) => {
                                                    setRecord((prev) => ({
                                                        ...prev,
                                                        studentId: e.target.value
                                                    }))
                                                }}
                                            />
                                        </td>
                                        <td className="pl-2">
                                            <input
                                                type="number"
                                                min="0" max="100"
                                                maxLength={0}
                                                className={`appearance-none m-0 p-0 ${INPUT_STYLE} w-fit h-10  text-md font-normal`}
                                                value={record.obtainedMarks}
                                                onChange={(e) => {
                                                    setRecord((prev) => ({
                                                        ...prev,
                                                        obtainedMarks: e.target.value
                                                    }))
                                                }}
                                            />
                                        </td>
                                        <td className="pl-2">
                                            <input
                                                type="number"
                                                min="0" max="100"
                                                maxLength={0}
                                                className={`appearance-none m-0 p-0 ${INPUT_STYLE} w-fit h-10  text-md font-normal`}
                                                value={record.totalMarks}
                                                onChange={(e) => {
                                                    setRecord((prev) => ({
                                                        ...prev,
                                                        totalMarks: e.target.value
                                                    }))
                                                }}
                                            />
                                        </td>
                                        <td className="pl-2">
                                            <input
                                                type="text"
                                                className={`appearance-none m-0 p-0 ${INPUT_STYLE} w-24 h-10  text-md font-normal`}
                                                value={(record.obtainedMarks && record.totalMarks) && ((record.obtainedMarks / record.totalMarks) * 100).toFixed(2) + '%'}
                                                disabled={true}
                                                onChange={() => {
                                                    alert("exceded")
                                                }}
                                            // onChange={(e) => {
                                            //     setRecord((prev) => ({
                                            //         ...prev,
                                            //         percentage: e.target.value
                                            //     }))
                                            // }}
                                            />
                                        </td>

                                        <td className="">
                                            <div className="flex items-center justify-center">
                                                <button
                                                    className="rounded-full p-2 focus:ring-1 focus:ring-offset-1 focus:ring-blue-500  leading-none  bg-gray-100 hover:bg-blue-200 focus:outline-none"
                                                    onClick={() => {
                                                        alert("added")
                                                        // const result = tableData.filter((item) => item?.studentId === student.studentId)[0];
                                                        // console.log(result);
                                                        // localStorage.setItem('ViewStudent', JSON.stringify(result));
                                                    }}
                                                >
                                                    <GrAdd />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                } */}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Table;
